export const IconTelegram: {
  name: 'icon_telegram-35f7a985d496'
} = {
  name: 'icon_telegram-35f7a985d496'
}
